import { useAtomValue } from "jotai";
import type { ReactNode } from "react";

import { MobileNavigationBar } from "@whoosh/design-system/src/patterns/patronApp/MobileNavigationBar/MobileNavigationBar";
import type { MobileNavigationBarProps } from "@whoosh/design-system/src/patterns/patronApp/MobileNavigationBar/MobileNavigationBar";

import { LanguageSelectContainer } from "../../../features/LanguagePreference";
import { sessionUserAtom } from "../../../features/Session";
import { Topbar } from "../../Topbar";
import {
  useShowPageHeader,
  type UseShowPageHeaderOptions,
} from "./useShowPageHeader";

export const usePatronTopbarMobileHeaderNav = (
  legacyNavigationBarProps: MobileNavigationBarProps,
  options?: UseShowPageHeaderOptions
): {
  customNavigationBar: ReactNode;
  navigationBarVariant: "topbar" | "default";
} => {
  const { mobileNavSlot, navigationBarVariant } = useShowPageHeader(options);
  const isSignedIn = Boolean(useAtomValue(sessionUserAtom));

  const customNavigationBar =
    mobileNavSlot === "embedded-topbar" ? (
      <Topbar />
    ) : mobileNavSlot === "legacy-navigation-bar" ? (
      <MobileNavigationBar
        {...legacyNavigationBarProps}
        rightElement={
          <LanguageSelectContainer
            syncToUserProfile={isSignedIn}
            testID="legacy-navigation-language-select"
          />
        }
      />
    ) : null;

  return { customNavigationBar, navigationBarVariant };
};
